import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {GeneralService} from './general.service';
import {Injectable} from '@angular/core';
import * as _ from 'lodash';

@Injectable()
export class EdiTypeService extends GeneralService {

    constructor(protected http: HttpClient) {
        super(http);
    }

    public getItems(page): Observable<any> {
        const current_page = page.pageNumber + 1;
        let params = new HttpParams();
        params = params.append('perPage', page.size);
        params = params.append('page', current_page);
        if (!_.isUndefined(page.sortParams)) {
            for (const key of Object.keys(page.sortParams)) {
                const value = page.sortParams[key];
                params = params.append('sort', key + ',' + value );
            }
        }
        if (!_.isUndefined(page.filterParams)) {
            for (const key of Object.keys(page.filterParams)) {
                const value = page.filterParams[key];
                if (value && value !== '') {
                    params = params.append('filter', key + ',' + value );
                }
            }
        }
        return this.http.get(this.apiUrl + '/edi-types', { params : params });
    }

    getById(id: number): Observable<object> {

        const url = `${this.apiUrl}/edi-types/${id}`;
        return this.http.get(url)
            .map(
                data => this.extractPayload(data)
            )
            .catch(this.handleError);
    }

    save(data: object, isCreate: boolean): Observable<object> {
        return this.update( data );
    }

    private update(editype: any): Observable<object> {
        const url = `${this.apiUrl + '/edi-types'}/${editype.id}`;
        return this.http.put(url, editype)
            .catch(this.handleError);
    }

    public sync(): Observable<any> {
        const url = `${this.apiUrl}/edi-types/sync`;
        return this.http.post(url, {}).catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/services/editype.service.ts